import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Adoption from '../components/Adoption';
import CategorySection from '../components/CategorySection';
import Counter from '../components/Counter';
import MainSlider from '../components/MainSlider';
import NewsletterParent from '../components/NewsletterParent';




function Home() {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);


	return (


		<main>
			<Helmet>
				<title>Acceuil - Animalia</title>
				<meta name="description" content="Découvrez notre sélection Acceuil chez Animalia." />
			</Helmet>

			<MainSlider />
			{/* <Find/> */}
			{/* <FeatureBar/> */}
			<br />
			{/* <CategoriesList/> */}
			<CategorySection />
			<Counter />
			<Adoption />
			{/* <AnimaliaCategories /> */}
			{/* <Testimonial /> */}
			{/* <BlogsHome/> */}
			<NewsletterParent />

		</main>

	)
}

export default Home;
